import React, {Component} from "react";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {LanguageService} from "../language/LanguageService";
import styled from "styled-components";
import {ErrorpageWrap, TabItem, TitleBarContainer, TitleBarContents, TitleBarItem} from "../style/CommonStyledComponents";
import {CategoryRepository, emptyCategoryDetail, ICategory, ICategoryDetail} from "../repositories/category/CategoryRepository";
import CategoryStore from "../repositories/category/CategoryStore";
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import {
  ALL_DOCTYPE_OF_COMMUNITY_DOCUMENT_TAB,
  ALL_DOCTYPE_OF_DOCUMENT_TAB,
  ALL_DOCTYPE_OF_TECHNICAL_DOCUMENT_TAB,
  emptyICountSsqDataByDocType,
  ICountOfEachDocTypeRequest,
  ICountsOfEachDocType,
  SsqDataRepository
} from "../repositories/SsqDataRepository";
import {DocType} from "../definitions/DocType";
import CategoryCards from "./CategoryCards";
import {SsqImages} from "../images/SsqImages";
import {fontFamilyBold, fontFamilyMedium, fontFamilyRegular} from "../style/fonts";
import ProductDownloadTabPanel from "./ProductDownloadTabPanel";
import ProductTechnicalTabPanel from "./ProductTechnicalTabPanel";
import {TargetType} from "../definitions/TargetType";
import ProductSoftwareTabPanel from "./ProductSoftwareTabPanel";
import ProductTrainingTabPanel from "./ProductTrainingTabPanel";
import {ProductTabType} from "../definitions/ProductTabType";
import TagManager from "react-gtm-module";
import ProductSquareTabPanel from "productpage/ProductSquareTabPanel";
import ProductSampleTabPanel from "productpage/ProductSampleTabPanel";
import {ProductFilter} from "./ProductFilter";
import clsx from "clsx";

import {PERIOD_TYPE, SORT_TYPE} from "communitypage/common/CommunityFilter";

import img_icon_filter from "images/community/icon_filter.svg";
import img_icon_filter_on from "images/community/icon_filter_on.svg";
import {connect} from "react-redux";
import {IfLoginInfo} from "models/IfLoginInfo";
import {isEqual} from "lodash-es";
import {LANG_EN_US, LANG_KO_KR, langutil} from "language/langutil";
import axios from "axios";
import {i18ntrans, tcommona} from "language/i18nkey";
import {getLangSuffix, HelmetTitleAndH1} from "../ctls/common/HelmetTitleAndH1";
import svcs from "services";
import ProductSwServicePanel from "productpage/ProductSwServicePanel";
import {IfDocCommentInfo} from "models/IfSsqDataDocCommentEntity";
import {ssqutil} from "util/ssqutil";

interface IProductPageMatchParams {
  categoryId: string;
  country?: string;
  lang?: string;
}

export interface ISrchParam {
  sortType: string;
  periodType: string;
  tagType: string[];
  categoryId: number;
  keyword: string;
}


interface Props extends RouteComponentProps<IProductPageMatchParams> {
  languageService: LanguageService;
  categoryRepository: CategoryRepository;
  ssqDataRepository: SsqDataRepository;
  categoryStore: CategoryStore;
  loginInfo: IfLoginInfo;
  displayLoginPopup?: Function;
}

interface State {
  selectedDocType: string;
  selectedTab: string;
  ssqDataDocumentsAllCountsByCategoryId: ICountsOfEachDocType;
  selectedCategoryDetail: ICategoryDetail;
  innerWidth: number;
  srchParam: ISrchParam;
  openFilter: boolean;
  showEmptyResult: boolean;
  resetFilter: boolean;
  clickFilter: boolean;
  filterHover: boolean;
  preSortType: string;
  commentList: Array<IfDocCommentInfo>;
}

class ProductPage extends Component<Props, State> {

  filterRef = React.createRef<HTMLButtonElement>();
  private filteringTimer: any = null;
  private readonly FILTERING_DEBOUNCING_DELAY_TIME_MS = 200;

  constructor(props: Props) {
    super(props);


    this.state = {
      commentList: [],
      selectedDocType: DocType.MANUAL,
      selectedTab: ProductTabType.DOWNLOAD,
      ssqDataDocumentsAllCountsByCategoryId: emptyICountSsqDataByDocType,
      selectedCategoryDetail: emptyCategoryDetail,
      innerWidth: window.innerWidth,
      srchParam: {
        sortType: SORT_TYPE.UPDATE,
        periodType: '',
        tagType: [],
        categoryId: 0,
        keyword: '',
      },
      openFilter: false,
      showEmptyResult: false,
      resetFilter: false,
      clickFilter: false,
      filterHover: false,
      preSortType: SORT_TYPE.UPDATE,
    };
  }

  handleResize = () => {
    if (this.filteringTimer) {
      clearTimeout(this.filteringTimer);
    }
    this.filteringTimer = setTimeout(
      async () => this.setState({
        innerWidth: window.innerWidth
      }),
      this.FILTERING_DEBOUNCING_DELAY_TIME_MS
    );
  };

  async componentDidMount() {
    if (!langutil.isCountryLangUrl()) { // url에 국가/언어가 없으면.
      const categoryId = this.props.match.params.categoryId;
      const info: ICategory = (await axios.get('/api/guest/ssqData/category/get/' + categoryId)).data;
      document.location.href = langutil.getCountryLangUrl(info.lang);
      return; // 다음으로 진행하지 않도록.
    }

    await this.loadAllCategories();
    const {categoryId} = this.props.match.params;
    if (Number(this.props.match.params.categoryId) !== 0) {
      await this.getSelectedCategoryDetail(Number(categoryId));
    }
    await this.getSsqDataDocumentsAllCountsByCategoryId(Number(categoryId));
    window.scrollTo(0, 0);

    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    //console.log("product page : match.params", this.props.match.params);
  }

  async componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    const selectedCategoryId = this.props.match.params.categoryId;

    if (prevProps.match.params.categoryId != selectedCategoryId || prevState.srchParam !== this.state.srchParam) {
      await this.getSelectedCategoryDetail(Number(selectedCategoryId));
      await this.getSsqDataDocumentsAllCountsByCategoryId(Number(selectedCategoryId));
    }

    if (prevState.ssqDataDocumentsAllCountsByCategoryId !== this.state.ssqDataDocumentsAllCountsByCategoryId) {
      const isEmpty = Object.values(this.state.ssqDataDocumentsAllCountsByCategoryId).reduce((prev, curr) => {
        return prev + curr;
      }, 0) === 0;
      if (isEmpty) {
        this.setState({showEmptyResult: true});
      } else {
        this.setState({showEmptyResult: false});
      }

    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  async loadAllCategories() {
    if (this.props.categoryStore.allCategories.length === 0) {
      let language = this.props.languageService.getLanguage();
      const allCategories = await this.props.categoryRepository.getExposedCategories(language);
      await this.props.categoryStore.setAllCategories(allCategories);
    }
  }

  async getSelectedCategoryDetail(categoryId: number) {
    if (categoryId != 0) {
      let categoryDetail = await this.props.categoryRepository.getProductCategoryDetail(categoryId);
      if (categoryDetail && categoryDetail.id) {
        this.setState({
          selectedCategoryDetail: categoryDetail
        });
      } else {
        this.setState({
          selectedCategoryDetail: emptyCategoryDetail
        });
      }
    } else {
      this.setState({
        selectedCategoryDetail: emptyCategoryDetail
      });
    }
  }

  async getSsqDataDocumentsAllCountsByCategoryId(categoryId: number) {
    const {sortType, periodType, tagType, keyword} = this.state.srchParam;
    let countOfEachDocTypeRequest: ICountOfEachDocTypeRequest = {
      categoryId: categoryId,
      docTypes: ALL_DOCTYPE_OF_DOCUMENT_TAB.concat(ALL_DOCTYPE_OF_TECHNICAL_DOCUMENT_TAB, ALL_DOCTYPE_OF_COMMUNITY_DOCUMENT_TAB).filter(doc => doc !== "QNA_A"),
      exposeSiteLanguage: this.props.languageService.getLanguage(),
      roleOfLoggedInUser: TargetType.GUEST,
      categoryTypeName: "",
      sortType: sortType === SORT_TYPE.UPDATE ? 0 : sortType === SORT_TYPE.RECENT ? 1 : 2,
      periodType: periodType === PERIOD_TYPE.DEFAULT ? 0 :
        periodType === PERIOD_TYPE.WEEK ? 1 :
          periodType === PERIOD_TYPE.ONEMONTH ? 2 :
            periodType === PERIOD_TYPE.SIXMONTH ? 3 : 4,
      tagType,
      keyword,
      userId: this.props.loginInfo.userId
    };
    let ssqDataDocumentsAllCountsByCategoryId =
      await this.props.ssqDataRepository.getCountsOfEachDocType(countOfEachDocTypeRequest);
    this.setState({
      ssqDataDocumentsAllCountsByCategoryId: {
        ...ssqDataDocumentsAllCountsByCategoryId,
        eventCount: 0,
        tipCount: 0,
        noticeCount: 0,
        jobOfferCount: 0,
        jobSearchCount: 0
      }
    });
  }


  resetSortType = (sort: string) => {
    this.setState({preSortType: sort});
  };

  getTranslation(key: string): string {
    this.props.languageService.setNamespace("I18N_NAMESPACE_PRODUCT_PAGE");
    return this.props.languageService.getTranslationByKey(key) || "";
  }

  clickProductTabInTagManager(tabType: string) {
    TagManager.dataLayer({
      dataLayer: {
        "event": "click_product_tab",
        "click_product_tab": tabType
      }
    });
  }

  renderCategoryArea() {
    return <CategoryCards
      selectedCategoryId={Number(this.props.match.params.categoryId)}
      categoryRepository={this.props.categoryRepository}
      categoryStore={this.props.categoryStore}
      languageService={this.props.languageService}
      loadAllCategories={this.loadAllCategories.bind(this)}
    />;
  }

  getRelatedModelsStringForPreview(relatedModels: string) {
    let relatedModelsStringForPreview: string = relatedModels.replace(/;/gi, ', ');
    return <>{relatedModelsStringForPreview}</>;
  }

  getValidCategoryId(categoryIdString: string) {
    if (Number.isNaN(Number(categoryIdString))) {
      return 0;
    }
    return Number(categoryIdString);
  }


  isExistDocumentByTab(tabName: String): boolean {
    /*const cnts = this.state.ssqDataDocumentsAllCountsByCategoryId;
    if (tabName === ProductTabType.DOWNLOAD) {
      return cnts.manualCount +
        cnts.catalogCount +
        cnts.certificationCount +
        cnts.cadDataCount +
        cnts.dataSheetCount +
        cnts.softwareCount +
        cnts.osCount > 0;
    } else if (tabName === ProductTabType.TECHNICAL) {
      return cnts.applicationNoteCount + cnts.technicalGuideCount > 0;
    } else if (tabName === ProductTabType.SOFTWARE) {
      return cnts.osCount + cnts.softwareCount > 0;
    } else if (tabName === ProductTabType.TRAINING) {
      return cnts.educationVideoCount + cnts.educationNoteCount > 0;
    } else if (tabName === ProductTabType.SQUARE) {
      if ([LANG_EN, LANG_EN_US].includes(this.props.languageService.getLanguage()))
        return cnts.techGeneralCount > 0;
      else return cnts.qnaCount + cnts.techGeneralCount > 0;
    } else if (tabName === ProductTabType.SAMPLE_STORE) {
      return cnts.sampleCount + cnts.userSampleCount > 0;
    } else {
      return false;
    }*/
    return true;
  }

  setSrchParam = (srchParam: ISrchParam) => {
    this.setState({srchParam: {...srchParam, tagType: [...srchParam.tagType]}});
  };

  openFilter = (openState: boolean) => {
    this.setState({openFilter: openState});
  };

  renderFilterHover() {
    return <div className={"filter-hover"} onMouseEnter={(e) => {
      e.stopPropagation();
      this.setState({filterHover: true});
    }}
      onMouseLeave={(e) => {
        e.stopPropagation();
        this.setState({filterHover: false});
      }}>
      {this.getTranslation('I18N_PRODUCT_FILTER')}
    </div>;
  };

  //서브탭 초기화 버튼 클릭 시 사용
  resetFilter = () => {
    this.setState({resetFilter: !this.state.resetFilter});
  };

  renderTabAndDocumentTabPanel() {
    return <TabItem>
      <Tabs>
        <TapTopListArea>
          <div className={clsx("product-tab-line", this.state.selectedTab === DocType.SW_SERVICE ? "on" : "")}>
            <div className="left-blur"></div>
            <div className="right-blur"></div>
            <TabList id={"product_tab"}>
              {this.isExistDocumentByTab(ProductTabType.DOWNLOAD) &&
                <Tab onClick={() => {
                  this.clickProductTabInTagManager(ProductTabType.DOWNLOAD);
                  this.setState({selectedTab: ProductTabType.DOWNLOAD});
                }}>
                  {this.getTranslation("I18N_TAB_DOWNLOAD")}</Tab>}
              {this.isExistDocumentByTab(ProductTabType.TECHNICAL) &&
                <Tab onClick={() => {
                  this.clickProductTabInTagManager(ProductTabType.TECHNICAL);
                  this.setState({selectedTab: ProductTabType.TECHNICAL});
                }}>
                  {this.getTranslation("I18N_TAB_PRODUCT_TECHNICAL")}</Tab>}
              {this.isExistDocumentByTab(ProductTabType.SOFTWARE) &&
                <Tab onClick={() => {
                  this.clickProductTabInTagManager(ProductTabType.SOFTWARE);
                  this.setState({selectedTab: ProductTabType.SOFTWARE});
                }}>
                  {this.getTranslation("I18N_TAB_SOFTWARE")}</Tab>}
              {this.isExistDocumentByTab(ProductTabType.TRAINING) &&
                <Tab onClick={() => {
                  this.clickProductTabInTagManager(ProductTabType.TRAINING);
                  this.setState({selectedTab: ProductTabType.TRAINING});
                }}>
                  {this.getTranslation("I18N_TAB_TRAINING")}</Tab>}
              {this.isExistDocumentByTab(ProductTabType.SQUARE) &&
                <Tab onClick={() => {
                  this.clickProductTabInTagManager(ProductTabType.SQUARE);
                  this.setState({selectedTab: ProductTabType.SQUARE});
                }}>
                  {this.getTranslation("I18N_TAB_SQUARE")}</Tab>}
              {this.isExistDocumentByTab(ProductTabType.SAMPLE_STORE) &&
                <Tab onClick={() => {
                  this.clickProductTabInTagManager(ProductTabType.SAMPLE_STORE);
                  this.setState({selectedTab: ProductTabType.SAMPLE_STORE});
                }}>
                  {this.getTranslation("I18N_TAB_SAMPLE_STORE")}</Tab>}
              {this.state.ssqDataDocumentsAllCountsByCategoryId.swServiceCount !== 0 &&
                <Tab onClick={() => {
                  this.clickProductTabInTagManager(ProductTabType.SW_SERVICE);
                  this.setState({selectedTab: ProductTabType.SW_SERVICE});
                }}>
                  {this.getTranslation("I18N_TAB_SW_SERVICE")}</Tab>}
            </TabList>
          </div>
          <div className={"btn-filter-box"}>
            <button className={`btn-filter ${this.state.openFilter ? 'on' : ''}`} ref={this.filterRef}
              onMouseEnter={(e) => {
                e.stopPropagation();
                this.setState({filterHover: true});
              }}
              onMouseLeave={(e) => {
                e.stopPropagation();
                this.setState({filterHover: false});
              }}
              onClick={() => {
                this.setState({clickFilter: !this.state.clickFilter});
              }}></button>
            {this.state.filterHover && this.renderFilterHover()}
          </div>

          <ProductFilter setSrchParam={this.setSrchParam} categoryRepository={this.props.categoryRepository} filterRef={this.filterRef}
            languageService={this.props.languageService} setOpenFilter={this.openFilter} filterClick={this.state.clickFilter}
            reset={this.state.resetFilter} emptyResult={this.state.showEmptyResult} preSortType={this.resetSortType}
            selectTab={this.state.selectedTab}
          />

        </TapTopListArea>
        {this.isExistDocumentByTab(ProductTabType.DOWNLOAD) && <TabPanel>
          <ProductDownloadTabPanel
            selectedCategoryId={this.getValidCategoryId(this.props.match.params.categoryId)}
            languageService={this.props.languageService}
            categoryRepository={this.props.categoryRepository}
            ssqDataRepository={this.props.ssqDataRepository}
            categoryStore={this.props.categoryStore}
            getTranslation={this.getTranslation.bind(this)}
            loadAllCategories={this.loadAllCategories.bind(this)}
            srchParam={this.state.srchParam}
            loginInfo={this.props.loginInfo}
            resetFilter={this.resetFilter}
            preSortType={this.state.preSortType}
          />
        </TabPanel>}
        {this.isExistDocumentByTab(ProductTabType.TECHNICAL) && <TabPanel>
          <ProductTechnicalTabPanel
            commentList={this.state.commentList}
            displayLoginPopup={this.props.displayLoginPopup}
            selectedCategoryId={this.getValidCategoryId(this.props.match.params.categoryId)}
            languageService={this.props.languageService}
            categoryRepository={this.props.categoryRepository}
            ssqDataRepository={this.props.ssqDataRepository}
            categoryStore={this.props.categoryStore}
            getTranslation={this.getTranslation.bind(this)}
            srchParam={this.state.srchParam}
            resetFilter={this.resetFilter}
            preSortType={this.state.preSortType}
            loadAllCategories={this.loadAllCategories.bind(this)}
          />
        </TabPanel>}
        {this.isExistDocumentByTab(ProductTabType.SOFTWARE) && <TabPanel>
          <ProductSoftwareTabPanel
            selectedCategoryId={this.getValidCategoryId(this.props.match.params.categoryId)}
            languageService={this.props.languageService}
            categoryRepository={this.props.categoryRepository}
            ssqDataRepository={this.props.ssqDataRepository}
            categoryStore={this.props.categoryStore}
            getTranslation={this.getTranslation.bind(this)}
            loadAllCategories={this.loadAllCategories.bind(this)}
            srchParam={this.state.srchParam}
            loginInfo={this.props.loginInfo}
            resetFilter={this.resetFilter}
            preSortType={this.state.preSortType}
          />
        </TabPanel>}
        {this.isExistDocumentByTab(ProductTabType.TRAINING) && <TabPanel>
          <ProductTrainingTabPanel
            selectedCategoryId={this.getValidCategoryId(this.props.match.params.categoryId)}
            languageService={this.props.languageService}
            categoryRepository={this.props.categoryRepository}
            ssqDataRepository={this.props.ssqDataRepository}
            categoryStore={this.props.categoryStore}
            getTranslation={this.getTranslation.bind(this)}
            loadAllCategories={this.loadAllCategories.bind(this)}
            srchParam={this.state.srchParam}
            loginInfo={this.props.loginInfo}
            resetFilter={this.resetFilter}
            preSortType={this.state.preSortType}
          />
        </TabPanel>}
        {this.isExistDocumentByTab(ProductTabType.SQUARE) && <TabPanel>
          <ProductSquareTabPanel
            commentList={this.state.commentList}
            displayLoginPopup={this.props.displayLoginPopup}
            selectedCategoryId={this.getValidCategoryId(this.props.match.params.categoryId)}
            languageService={this.props.languageService}
            categoryRepository={this.props.categoryRepository}
            ssqDataRepository={this.props.ssqDataRepository}
            categoryStore={this.props.categoryStore}
            getTranslation={this.getTranslation.bind(this)}
            loadAllCategories={this.loadAllCategories.bind(this)}
            srchParam={this.state.srchParam}
            resetFilter={this.resetFilter}
            preSortType={this.state.preSortType}
            loginInfo={this.props.loginInfo}
          />
        </TabPanel>}
        {this.isExistDocumentByTab(ProductTabType.SAMPLE_STORE) && <TabPanel>
          <ProductSampleTabPanel
            commentList={this.state.commentList}
            displayLoginPopup={this.props.displayLoginPopup}
            selectedCategoryId={this.getValidCategoryId(this.props.match.params.categoryId)}
            languageService={this.props.languageService}
            categoryRepository={this.props.categoryRepository}
            ssqDataRepository={this.props.ssqDataRepository}
            categoryStore={this.props.categoryStore}
            getTranslation={this.getTranslation.bind(this)}
            loadAllCategories={this.loadAllCategories.bind(this)}
            srchParam={this.state.srchParam}
            resetFilter={this.resetFilter}
            preSortType={this.state.preSortType}
            loginInfo={this.props.loginInfo}
          />
        </TabPanel>}

        <TabPanel>
          <ProductSwServicePanel
            displayLoginPopup={this.props.displayLoginPopup}
            selectedCategoryId={this.getValidCategoryId(this.props.match.params.categoryId)}
            languageService={this.props.languageService}
            categoryRepository={this.props.categoryRepository}
            ssqDataRepository={this.props.ssqDataRepository}
            categoryStore={this.props.categoryStore}
            getTranslation={this.getTranslation.bind(this)}
            loadAllCategories={this.loadAllCategories.bind(this)}
            srchParam={this.state.srchParam}
            resetFilter={this.resetFilter}
            preSortType={this.state.preSortType}
            loginInfo={this.props.loginInfo}
          />
        </TabPanel>
      </Tabs>
    </TabItem>;
  }

  renderSelectedCategoryPreview() {
    let category = this.state.selectedCategoryDetail;
    return category.id !== 0 &&
      <SideProductDetail tDiscontinue={i18ntrans.admin('I18N_SUBJECT_DISCONTINUE')}>
        <div className={clsx("side-product-head", category.discontinue ? 'sold-out' : '')}> {/* 단종일 경우 sold-out를 추가합니다.*/}
          <img
            className={"categoryPreview-img"}
            alt={`category-${category.id}.png`}
            src={ssqutil.getCdnUrl(category.imageBlobKey)}
            onError={(e: any) => {
              e.target.src = SsqImages.common.icon.noImage();
              e.target.className = "no-image";
              e.target.alt = "no_image.svg";
            }}
          />
        </div>
        <div className="side-product-content">
          {this.props.languageService.getLanguage() === LANG_KO_KR
            &&
            this.renderPreviewKr(category)
            ||
            this.renderPreviewEn(category)
          }

          {category.homepageUrl && <HomepageLinkButton className={"go-homepage"} href={
            category.homepageUrl.toLowerCase().startsWith("http") ? category.homepageUrl : "//" + category.homepageUrl
          }
            aria-label={"categoryPreview-homepage-link"}
            target="_blank"
          >{this.getTranslation("I18N_DOC_HOMEPAGE_BUTTON")}
          </HomepageLinkButton>}
          {category.relatedModels && <div className={"categoryPreview-models-name"}>{this.getTranslation("I18N_CATEGORY_PREVIEW_MODEL")}</div>}
          <div className={"categoryPreview-models"}>
            {this.getRelatedModelsStringForPreview(category.relatedModels)}
          </div>
        </div>
      </SideProductDetail>;
  }

  renderPreviewKr(category: ICategoryDetail) {
    return <>
      <p className="title">{category.name}</p>
      <p className="title-sm">{category.cardDescription}</p>
      <p className="product-content-text">{category.description}</p>
    </>;
  }

  renderPreviewEn(category: ICategoryDetail) {
    return <>
      <p className="title">{category.name}</p>
      <p className="title-sm">{category.cardDescription}</p>
      <p className="product-content-text">{category.description}</p>
    </>;
  }

  renderNoDocumentPage() {
    return <ErrorpageWrap className={"ErrorpageWrap"}>
      <div className={"Errorpage"}>
        <img alt={"empty_search_result.svg"} src={SsqImages.common.icon.emptySearchResult()}/>
        <p className={"error-tit"}>{this.getTranslation("I18N_NO_DOCUMENT")}</p>
        <p className={"error-txt"}>{this.getTranslation("I18N_NO_DOCUMENT_NOTICE")}</p>
        {
          !isEqual(this.state.srchParam, {
            sortType: '',
            periodType: '',
            tagType: [],
            categoryId: 0,
            keyword: '',
          }) &&
          <button className="error-button" onClick={() => this.setState({resetFilter: !this.state.resetFilter})}>
            {this.getTranslation("I18N_NO_DOCUMENT_RESET")}
          </button>
        }
      </div>
    </ErrorpageWrap>;
  }

  gearBoxLink() {
    const accessCountry = this.props.languageService.getLanguage();
    if (accessCountry == LANG_KO_KR) return 'https://www.ls-electric.com/gearbox/ko/motor'; // korean
    return 'https://www.ls-electric.com/gearbox/en/motor'; // global, us
  }

  linearMotorLink() {
    const accessCountry = this.props.languageService.getLanguage();
    if (accessCountry == LANG_KO_KR) return 'https://www.ls-electric.com/linear_motor/ko/product-search/step1'; // korean
    return 'https://www.ls-electric.com/linear_motor/en/product-search/step1'; // global, us
  }

  render() {
    const {country, lang} = langutil.splitLangCode(this.props.languageService.lang());

    const pagetitle = () => {
      return tcommona('I18N_COMMON_TIT_PROD',
        this.state.selectedCategoryDetail.id ?
          [svcs.storeCategory.getCategorySearchItemById(this.state.selectedCategoryDetail.id).parentsCategory, ' - '] : [], [getLangSuffix()]);
    };
    return <div>
      <HelmetTitleAndH1
        title={pagetitle()}/>
      <ProductPageContainer aria-label={"product-page"}>
        <TitleBarContainer>
          <TitleBarContents className={"container"}>
            <TitleBarItem><a href={`/${country}/${lang}/main`}>{this.getTranslation("I18N_TITLE_MAIN")}</a></TitleBarItem>
            <TitleBarItem className="selected">{this.getTranslation("I18N_TITLE_PRODUCT")}</TitleBarItem>
          </TitleBarContents>
        </TitleBarContainer>
        <ProductContentsContainer>
          <div className={"wrapper container"}>
            <ProductContents>
              {this.renderCategoryArea()}
            </ProductContents>
            <CategoryPreviewContainer>
              {this.isRenderPreview() && this.renderSelectedCategoryPreview()}
            </CategoryPreviewContainer>

            {/* 제품 선정 가이드 시작 */}
            <ProductSelectGuide>
              <div className="right-guide">
                <div className="g-header">
                  <p>{this.getTranslation('I18N_PRODUCT_SELECTOR')}</p>
                </div>
                <ul className="guide-list">
                  <li>
                    <a href={`/${country}/${lang}/productselector?view=drive`}>
                      <button>
                        <img src={SsqImages.product.SideGuideDrive()} alt=""/>
                        <p>Drive {this.props.languageService.getLanguage() == LANG_KO_KR && this.getTranslation('I81N_PRODUCT_SELECTOR_TITLE')}</p>
                      </button>
                    </a>
                  </li>
                  <li>
                    <a href={`/${country}/${lang}/productselector?view=hmi`}>
                      <button>
                        <img src={SsqImages.product.SideGuideHmi()} alt=""/>
                        <p>HMI {this.props.languageService.getLanguage() == LANG_KO_KR && this.getTranslation('I81N_PRODUCT_SELECTOR_TITLE')}</p>
                      </button>
                    </a>
                  </li>
                  {this.props.languageService.getLanguage() !== LANG_EN_US && <li>
                    <a href={this.gearBoxLink()} target={'_blank'}>
                      <button>
                        <img src={SsqImages.product.SideGuideDeboost()} alt=""/>
                        <p>{this.getTranslation('I18N_PRODUCT_SELECTOR_GEARBOX')} {this.props.languageService.getLanguage() == LANG_KO_KR && this.getTranslation('I81N_PRODUCT_SELECTOR_TITLE')}</p>
                      </button>
                    </a>
                    <button className="link"><img src={SsqImages.product.SideGuideLink()} alt=""/></button>
                  </li>}
                  {this.props.languageService.getLanguage() !== LANG_EN_US && <li>
                    <a href={this.linearMotorLink()} target={'_blank'}>
                      <button>
                        <img src={SsqImages.product.SideGuideMotor()} alt=""/>
                        <p>{this.getTranslation('I18N_PRODUCT_SELECTOR_LINEAR_MOTOR')}</p>
                      </button>
                    </a>
                    <button className="link"><img src={SsqImages.product.SideGuideLink()} alt=""/></button>
                  </li>}
                </ul>
              </div>
            </ProductSelectGuide>
            {/* 제품 선정 가이드 끝 / 제품탭보다 앞에 위치한 이유는 ProductTable보다 아래에 코드를 위치하면 sticky가 작동을 안하는 오류가 있습니다.*/}
            <ProductTable>
              {this.renderTabAndDocumentTabPanel()}
              {/*{this.state.showEmptyResult && this.renderNoDocumentPage()}*/}
            </ProductTable>
          </div>
        </ProductContentsContainer>
      </ProductPageContainer>
    </div>;
  }

  private isRenderPreview(): boolean {
    return this.state.innerWidth >= 1700;
  }
}

export default withRouter(connect((state: any) => ({
    loginInfo: state.main.loginInfo,
  })
)(ProductPage));

const SideProductDetail = styled.div<{ tDiscontinue: string }>`
  width: 22.4rem;
  position: absolute;
  left: -24rem;
  background: #fff;
  box-shadow: 0px .4rem 1.2rem rgba(0, 0, 0, 0.1);
  border-radius: .4rem;

  .side-product-head {

    padding: 3.2rem;
    border-bottom: .1rem solid #C7D6EA;
    position: relative;

    img {
      width: 16rem;
      height: 16rem;
    }

    &.sold-out {

      img {
        opacity: .3;
      }

      :before {
        content: "${p => p.tDiscontinue || "단종"}";
        min-width: 3.2rem;
        height: 1.7rem;
        line-height: 1.5rem;
        font-size: .8rem;
        ${fontFamilyMedium};
        position: absolute;
        top: 3.2rem;
        left: 3.2rem;
        z-index: 2;
        color: #7783A1;
        background: #F1F3F6;
        text-align: center;
        border-radius: 2rem;
        padding: 0 0.3rem;
        box-sizing: border-box;
        white-space: nowrap;
      }

    }
  }

  .side-product-content {

    padding: 2.4rem;

    p {
      ${fontFamilyRegular};
      font-size: 1.1rem;
      line-height: 1.6rem;
      color: #666E7A;
    }

    p.title {
      ${fontFamilyBold};
      font-size: 2rem;
      line-height: 2.8rem;
      color: #407EDB;
      margin-bottom: .4rem;
    }

    p.title-sm {
      ${fontFamilyMedium};
      font-size: 1.2rem;
      padding: .4rem 0;
      line-height: 1.8rem;
      color: #2A2C2F;
      margin-bottom: .2rem;
    }

    .categoryPreview-models-name {
      margin-top: 1.6rem;
    }

    .categoryPreview-models {
      font-size: 1rem;
      color: #666E7A;
      word-break: break-word;
    }
  }


  @media screen and (max-width: 1199px) {
    display: none;
  }
`;

export const ProductPageContainer = styled.div`

  position: relative;
  width: 100%;
  height: 100%;
  background: #EEF1F6;

  .sub-container {
    box-shadow: none !important;
  }

  .wrapper {
    position: relative;
  }

  .ErrorpageWrap {
    background: none;

    .Errorpage {
      min-height: 50rem;
      background-color: transparent;
    }
  }

  .blog-tab-area {
    background: #F7F8FB;
    min-height: 60rem;
  }

  .blog-more-btn {
    background: #F7F8FB;
  }

  @media screen and (max-width: 764px) {
    background: #fff;

    .blog-more-btn,
    .blog-tab-area {
      background: #fff;
    }
  }


`;

export const ProductContentsContainer = styled.div`
  width: 100%;
`;

export const ProductContents = styled.div`
  width: 100%;
  background: #EAEEF5;
  box-shadow: 0px 20px 20px rgb(0 0 0 / 10%);
  overflow: hidden;

  @media screen and (max-width: 1199px) {
    box-shadow: none;
  }
`;
export const ProductTable = styled.div`
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 20px 20px rgb(0 0 0 / 10%);
  //padding: 3rem;
  min-height: 70rem;

  .product-tab-line .left-blur, .product-tab-line .right-blur {
    display: none;
  }

  .view-more-area {
    width: calc(100% - 6.4rem);
    margin: 0 auto;
  }

  @media screen and (max-width: 1199px) {
    box-shadow: none;

    .product-tab-line {
      margin-bottom: 1.2rem;
      border-bottom: 1px solid #90A0B6;
    }

    .product-tab-line .left-blur {
      display: block;
      position: absolute;
      width: 2rem;
      height: 4.1rem;
      left: 0;
      top: 8px;
      background: linear-gradient(to right, #fff 30%, rgba(255, 255, 255, 0));
      z-index: 2;
    }

    .product-tab-line .right-blur {
      display: block;
      position: absolute;
      width: 2rem;
      height: 4.2rem;
      right: 4.9rem;
      top: 0.7rem;
      background: linear-gradient(to left, #fff 30%, rgba(255, 255, 255, 0));
      z-index: 2;
    }

    #product_tab {
      overflow-x: auto;
      overflow-y: hidden;
      margin-bottom: 0;
      padding: 0 3.6rem;
      width: calc(100% - 4.6rem);
      border-bottom: none;

      li {
        min-width: auto;
        padding: 0 2rem;
        flex: 0 0 auto;
      }

      ::-webkit-scrollbar {
        display: none;
      }
    }
  }
  @media screen and (max-width: 764px) {

    .product-tab-line {
      margin-bottom: 1.2rem;
      border-bottom: 1px solid #90A0B6;

      &.on {
        margin-bottom: 6.2rem;
      }
    }

    .product-tab-line .left-blur {
      display: block;
      position: absolute;
      width: 2rem;
      height: 4.1rem;
      left: 0;
      top: 8px;
      background: linear-gradient(to right, #fff 30%, rgba(255, 255, 255, 0));
      z-index: 2;
    }

    .product-tab-line .right-blur {
      display: block;
      position: absolute;
      width: 2rem;
      height: 4.2rem;
      right: 4.4rem;
      top: 0.8rem;
      background: linear-gradient(to left, #fff 30%, rgba(255, 255, 255, 0));
      z-index: 2;
    }

    #product_tab {
      overflow-x: auto;
      overflow-y: hidden;
      margin-bottom: 0;
      padding: 0 1.6rem;
      width: calc(100% - 4.6rem);
      border-bottom: none;

      li {
        min-width: auto;
        padding: 0 2rem;
        flex: 0 0 auto;
      }

      ::-webkit-scrollbar {
        display: none;
      }
    }

    .view-more-area {
      width: 100%
    }
  }
`;


const HomepageLinkButton = styled.a`
  color: white;
  width: 100%;
  height: 3rem;
  line-height: 3rem;
  font-size: 1.2rem;
  padding-left: 1.2rem;
  background: #407EDB url(${SsqImages.common.icon.pagelinkWhite()}) center right .4rem no-repeat;
  display: block;
  margin-top: 1.6rem;
  border-radius: 4px;

  :hover {
    background-color: #3B71C4;
  }

  :active {
    background-color: #3463AB;
  }
`;
const CategoryPreviewContainer = styled.div`
  position: sticky;
  top: 7.4rem;

  width: 22.4rem;
  background: #ffffff;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 4px;

  .previewimg {
    width: 22.4rem;
    height: 22.4rem;
    margin: 0 auto;
    padding: 1.2rem;
    line-height: 20rem;
    text-align: center;
  }

  .previewimg img {
    display: inline-block;
    margin: 0 auto;
    max-width: 16rem;
    vertical-align: middle;
  }

  .previewinfo {
    border-top: solid 1px #C7D6EA;
    padding: 2.4rem;
    max-height: 41.6rem;
    overflow-y: auto;

    ::-webkit-scrollbar {
      width: 15px;
    }

    ::-webkit-scrollbar-thumb {
      background-clip: padding-box;
      border: 5px solid #fff;
      border-radius: 10px;
    }

    .categoryPreview-name {
      font-size: 2rem;
      color: #407EDB;
      ${fontFamilyBold}
    }

    .categoryPreview-card-des {
      font-size: 1.2rem;
      margin: 1rem 0;
    }

    .categoryPreview-des {
      font-size: 1.1rem;
      color: #666E7A;
      ${fontFamilyRegular};
      word-break: keep-all;
      margin-bottom: 1.6rem;
    }

  }

  @media screen and (max-width: 1199px) {
    display: none;
  }
`;

export const SsqDataColumnTitles = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  font-size: 1.2rem;
  background: #D8E1EF;
  line-height: 4rem;
  padding: 0 0 0 2.4rem;
  justify-content: space-between;

  > div + div {
    margin-left: 1rem
  }

  > div {
    ${fontFamilyRegular};
  }

  .accordion-col-doc-num {
    width: 4%;
  }

  .accordion-col-doc-title {
    width: 62%;
  }

  .accordion-col-doc-bookmark {
    width: 5%;
    text-align: center;
  }

  .accordion-col-doc-share {
    width: 5%;
    text-align: center;
  }


  .accordion-col-description {
    width: 30%;
  }

  .accordion-col-doc-language {
    width: 7%;
  }

  .accordion-col-files {
    width: 18%;
  }

  .accordion-col-update-time {
    width: 7%;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.8px;
  }

  .accordion-col-click-count {
    width: 6%;
    text-align: center;
    margin-right: 0 !important;
  }

  .accordion-col-more {
    width: 4%;
  }

  @media screen and (max-width: 1199px) {
    > div {
      margin-right: 0 !important;
    }

    .accordion-col-doc-title {
      width: 35%
    }

    .accordion-col-description {
      display: none;
      width: auto
    }

    .accordion-col-update-time {
      width: 7% !important;
    }

    .accordion-col-files {
      width: 21% !important;
    }

    .accordion-col-click-count {
      width: 6% !important;
      text-align: center;
      margin-right: 0 !important;
    }

    .accordion-col-doc-language {
      width: 8% !important;
    }

    .accordion-col-doc-bookmark {
      width: 7% !important;
      margin-left: 0.5rem;
    }

    .accordion-col-doc-share {
      //width: 6% !important;
    }
  }
  @media screen and (max-width: 764px) {
    font-size: 12px;
    .accordion-col-update-time, .accordion-col-click-count, .accordion-col-doc-language {
      display: none;
      width: auto
    }

    .accordion-col-doc-num {
      width: 8% !important;
    }

    .accordion-col-doc-title {
      //width: calc(100% - 13rem) !important;
      width: 56% !important;
    }

    .accordion-col-files {
      width: 15rem !important;
    }

    .accordion-col-doc-bookmark {
      width: 16% !important;
    }

    .accordion-col-doc-share {
      width: 10% !important;
    }

    .accordion-col-more {
      width: 10% !important;
    }
  }
`;
export const SubTabButtons = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 1.6rem;
  padding: 0 3rem;
  width: calc(100% - 26rem);
  min-height: 32px;

  .swiper-container {
    margin: 0;
  }

  .tab-button {
    width: auto;
    min-width: 10rem;
    height: 3.2rem;
    line-height: 3.2rem;
    font-size: 1.3rem;
    color: #666E7A;
    cursor: pointer;
    text-align: center;
    border: solid 1px transparent;
    box-sizing: border-box;
    border-radius: 10rem;
    margin-right: 1rem;
    padding: 0 .8rem;

    span {
      color: #407EDB;
    }

    :hover {
      background: rgba(64, 126, 219, 0.1);
    }

    :active {
      background: rgba(64, 126, 219, 0.3);
    }
  }

  .selected {
    ${fontFamilyBold};
    color: #407EDB;
    background: rgba(64, 126, 219, 0.1);

    :hover {
      background: rgba(64, 126, 219, 0.2);
    }
  }

  .swiper-button-next, .swiper-button-prev {
    top: auto;
    bottom: 0
  }

  @media screen and (max-width: 1199px) {

    margin-bottom: 8px;
    overflow: auto;

    .tab-button {
      min-width: 10rem;
      width: auto;
      padding: 0 .5rem;
      margin-bottom: 8px;
      flex: 0 0 auto;
    }

    ::-webkit-scrollbar {
      display: none;
    }
  }
  @media screen and (max-width: 764px) {
    padding: 0 16px;
    width: 100%;
  }
`;
export const SwiperArrow = styled.div`
  p {
    background: linear-gradient(to right, rgba(248, 250, 251, 0), #ffffff 20px);
    width: 40px;
    height: 100%;
    position: absolute;
    right: -10px;
    top: 0;
    text-align: right;
    z-index: 2;
  }

  .swiper-button-disabled {
    display: none
  }

  .swiper-button-prev {
    right: auto;
    background: linear-gradient(to left, rgba(248, 250, 251, 0), #ffffff 20px);
  }

  @media screen and (max-width: 1199px) {
    .swiper-button-prev {
      left: -16px !important;
    }
  }
`;
export const SubTabTableArea = styled.div`

  padding-bottom: 3rem;

  @media screen and (min-width: 765px) and (max-width: 1199px) {
    .result-area {
      padding: 0 1.6rem;
    }
  }

  @media screen and (max-width: 764px) {
    padding-top: 4rem;
  }
`;

export const TapTopListArea = styled.div`
  padding: 1.6rem 3.2rem 0 3.2rem;

  .filter-hover {
    position: absolute;
    top: -1.4rem;
    left: 50%;
    transform: translateX(-50%);
    background: white;
    border: 0.5px solid #C7D6EA;
    border-radius: 4px;
    height: 1.8rem;
    line-height: 1.6rem;
    min-width: 42px;
    padding: 0 0.6rem;
    text-align: center;
    z-index: 2;
    font-size: 9px;
    white-space: nowrap;
    color: #7783A1;
    ${fontFamilyRegular};
  }


  .btn-filter-box {
    width: 3.2rem;
    height: 3.2rem;
    position: absolute;
    top: 2.2rem;
    right: 3.8rem;
  }

  .btn-filter {
    width: 3.2rem;
    height: 3.2rem;
    //background: url('./images/common/icon_filter.svg') no-repeat center;
    background-image: url(${img_icon_filter});
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 4px;
    flex-shrink: 0;
  }


  .btn-filter.on {
    background: #D9E5F7;
    //background: #D9E5F7 url('./images/common/icon_filter_on.svg') no-repeat center;
    background-image: url(${img_icon_filter_on});
    background-repeat: no-repeat;
    background-position: center;
  }

  @media screen and (max-width: 1199px) {
    padding: 6px 0 0 0;

    .btn-filter-box {
      top: 1.2rem;
      right: 3rem;
      z-index: 2;
    }
  }

  @media screen and (max-width: 764px) {

    .btn-filter-box {
      top: 1.2rem;
      right: .8rem;
    }
  }

`;

const ProductSelectGuide = styled.div`
  position: sticky;
  top: 7.4rem;

  .right-guide {
    width: 8rem;
    position: absolute;
    left: 121.6rem;
    background: #fff;
    box-shadow: 0px .4rem 2rem rgba(0, 0, 0, 0.1);
    border-radius: .4rem;
  }


  .g-header {
    background: #41444A;
    height: 2rem;
    border-radius: 4px 4px 0 0;

    p {
      ${fontFamilyMedium};
      font-size: .9rem;
      line-height: 2rem;
      text-align: center;
      color: #fff;
    }
  }

  ul.guide-list {

    li {
      width: 100%;
      height: 8rem;
      position: relative;
      border-bottom: .1rem solid #EEF1F6;

      :last-child {
        border-bottom: none;
      }

      :hover {
        background: rgba(9, 120, 255, .1);
      }

      button {
        width: 100%;
        height: 100%;
        text-align: center;

        p {
          color: #666E7A;
          ${fontFamilyRegular};
          font-size: 1.1rem;
        }
      }

      button.link {
        position: absolute;
        top: .8rem;
        right: .8rem;
        width: 16px;
        height: 16px;
      }
    }
  }


  @media screen and (max-width: 1400px) {
    display: none;
  }

`;